import React, { useState, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const checkLoginStatus = () => {
      const token = localStorage.getItem('token');
      setIsLoggedIn(!!token);
    };

    checkLoginStatus();
    window.addEventListener('storage', checkLoginStatus);

    return () => {
      window.removeEventListener('storage', checkLoginStatus);
    };
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('token');
    setIsLoggedIn(false);
    navigate('/');
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="sticky top-0 bg-gradient-to-r from-green-400 to-yellow-400 text-white py-4 shadow-md border-b border-gray-300 z-50">
      <div className="container mx-auto px-4 flex justify-between items-center">
        {/* Left: Brand Logo */}
        <NavLink to="/" className="flex items-center gap-2">
          <img src="/Images/logo1.png" alt="Best3inTennis Logo" className="h-12 w-auto" />
        </NavLink>

        {/* Center: Navigation Menu */}
        <nav className="hidden md:flex space-x-6">
          <NavLink to="/mental-toughness-book" className="text-white font-medium hover:text-yellow-100 transition duration-300">Mental Toughness Book</NavLink>
          <NavLink to="/log-book-hub" className="text-white font-medium hover:text-yellow-100 transition duration-300">Log Books</NavLink>
          <NavLink to="/online-match-tracking" className="text-white font-medium hover:text-yellow-100 transition duration-300">Online Match Tracking</NavLink>
          <NavLink to="/extras-shop" className="text-white font-medium hover:text-yellow-100 transition duration-300">Shop</NavLink>
          <NavLink to="/mental-edge-blog" className="text-white font-medium hover:text-yellow-100 transition duration-300">Blog</NavLink>
        </nav>

        {/* Right: Login / Join Free */}
        <div className="flex items-center space-x-2 md:space-x-4">
          {!isLoggedIn && (
            <button onClick={() => navigate('/login', { state: { showRegister: true } })} className="md:hidden bg-yellow-500 hover:bg-yellow-600 text-green-800 font-semibold py-2 px-3 rounded-md transition duration-300 text-sm">
              JOIN
            </button>
          )}
          <div className="hidden md:flex items-center space-x-4">
            {isLoggedIn ? (
              <>
                <NavLink to="/dashboard" className="text-white font-medium hover:text-yellow-100 transition duration-300">Dashboard</NavLink>
                <button onClick={handleLogout} className="bg-green-500 hover:bg-green-600 text-white font-semibold py-2 px-4 rounded-md transition duration-300">Logout</button>
              </>
            ) : (
              <>
                <NavLink to="/login" className="text-white font-medium hover:text-yellow-100 transition duration-300">Login</NavLink>
                <button onClick={() => navigate('/login', { state: { showRegister: true } })} className="bg-yellow-500 hover:bg-yellow-600 text-green-800 font-semibold py-2 px-4 rounded-md transition duration-300">JOIN FREE</button>
              </>
            )}
          </div>
          <button onClick={toggleMenu} className="md:hidden text-white focus:outline-none">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16"></path>
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {isMenuOpen && (
        <nav className="md:hidden bg-white py-4 border-t border-gray-300 shadow-md">
          <div className="container mx-auto px-4 flex flex-col space-y-2">
          <div className="space-y-2">
            <NavLink to="/mental-toughness-book" onClick={toggleMenu} className="block text-green-800 hover:text-green-700 transition duration-300">Mental Toughness Book</NavLink>
            <NavLink to="/log-book-hub" onClick={toggleMenu} className="block text-green-800 hover:text-green-700 transition duration-300">Log Books</NavLink>
            <NavLink to="/online-match-tracking" onClick={toggleMenu} className="block text-green-800 hover:text-green-700 transition duration-300">Online Match Tracking</NavLink>
            <NavLink to="/extras-shop" onClick={toggleMenu} className="block text-green-800 hover:text-green-700 transition duration-300">Shop</NavLink>
            <NavLink to="/mental-edge-blog" onClick={toggleMenu} className="block text-green-800 hover:text-green-700 transition duration-300">Blog</NavLink>
          </div>
            {isLoggedIn ? (
              <>
                <NavLink to="/dashboard" onClick={toggleMenu} className="block text-green-800 hover:text-green-700 transition duration-300">Dashboard</NavLink>
                <button onClick={handleLogout} className="block w-full text-left text-green-800 hover:text-green-700 transition duration-300 py-2 px-4">Logout</button>
              </>
            ) : (
              <>
                <NavLink to="/login" onClick={toggleMenu} className="block text-green-800 hover:text-green-700 transition duration-300">Login</NavLink>
                <button onClick={() => { navigate('/login', { state: { showRegister: true } }); setIsMenuOpen(false); }} className="block w-full text-left bg-yellow-500 hover:bg-yellow-600 text-green-800 font-semibold py-2 px-4 rounded-md transition duration-300">JOIN FREE</button>
              </>
            )}
          </div>
        </nav>
      )}
    </header>
  );
};

export default Header;

